import { memo } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const StyledRota = styled(Link)<{ color: string }>`
  color: ${(props) => props.color};
  text-decoration: none;
  width: 100%;
  max-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between

  &:hover {
    background: #ececec;
    transition: 0.5s;
  }
`;

export default memo(StyledRota);
